import { useState } from 'react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { ScrollArea } from '../../ui/scroll-area';
import { FileText } from 'lucide-react';

/**
 * Lesson transcript/content display
 */
export const LessonContent = ({ currentSection }) => {
  const [showTranscript, setShowTranscript] = useState(true);

  return (
    <Card>
      <CardHeader className="py-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2">
            <FileText className="h-5 w-5" />
            Lesson Content
          </CardTitle>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => setShowTranscript(!showTranscript)}
          >
            {showTranscript ? 'Hide' : 'Show'}
          </Button>
        </div>
      </CardHeader>
      {showTranscript && (
        <CardContent>
          <ScrollArea className="h-64">
            <div className="prose prose-sm max-w-none">
              {currentSection?.ai_script?.split('\n').map((paragraph, i) => (
                paragraph.trim() && (
                  <p key={`p-${i}`} className="mb-3 text-muted-foreground leading-relaxed">
                    {paragraph}
                  </p>
                )
              ))}
            </div>
          </ScrollArea>
        </CardContent>
      )}
    </Card>
  );
};

export default LessonContent;
